export const jumpToTarget = target => {

  const scrollDistance = $(target).offset().top - $('#siteHeader').outerHeight();

  $('html, body').stop().animate({
    scrollTop: scrollDistance
  }, 900, 'swing');
}



// WEBPACK FOOTER //
// ./src/apm/js/helpers/jumpToTarget.js